import { BaseEnum } from "./baseEnum";

const listRecruitmentVacancyPurposeEnum: Array<RecruitmentVacancyPurpose> = [];

export class RecruitmentVacancyPurpose extends BaseEnum {
	/** Código usado pela API/métricas quando a finalidade não foi informada (legado). */
	static readonly NOT_INFORMED_ID = 0;
	static readonly NOT_INFORMED_LABEL = 'Não Informado';

	static HeadcountIncrease = new RecruitmentVacancyPurpose(1, "HeadcountIncrease", "Aumento de Quadro");
	static Replacement = new RecruitmentVacancyPurpose(2, "Replacement", "Reposição");

	constructor(public id: number, public value: string, public label: string) {
		super(id, value, label);
		listRecruitmentVacancyPurposeEnum.push(this);
	}

	public static buildListEnum(): Array<BaseEnum> {
		return listRecruitmentVacancyPurposeEnum;
	}

	/**
	 * Normaliza purpose nulo/vazio para NOT_INFORMED_ID (legado das métricas).
	 * Valores válidos do enum permanecem inalterados.
	 */
	public static normalizeCode(purpose: number | string | null | undefined): number {
		if (purpose == null || purpose === '') {
			return RecruitmentVacancyPurpose.NOT_INFORMED_ID;
		}

		const asNumber = typeof purpose === 'number' ? purpose : Number(String(purpose).trim());
		return Number.isFinite(asNumber) ? asNumber : RecruitmentVacancyPurpose.NOT_INFORMED_ID;
	}

	public static isNotInformed(purpose: number | string | null | undefined): boolean {
		return RecruitmentVacancyPurpose.normalizeCode(purpose) === RecruitmentVacancyPurpose.NOT_INFORMED_ID;
	}

	public static resolve(purpose: number | string | null | undefined): RecruitmentVacancyPurpose | undefined {
		if (purpose == null || purpose === '') {
			return undefined;
		}

		if (typeof purpose === 'number') {
			return RecruitmentVacancyPurpose.getById(purpose) as RecruitmentVacancyPurpose | undefined;
		}

		const trimmed = String(purpose).trim();
		const asNumber = Number(trimmed);
		if (trimmed !== '' && Number.isFinite(asNumber) && String(asNumber) === trimmed) {
			return RecruitmentVacancyPurpose.getById(asNumber) as RecruitmentVacancyPurpose | undefined;
		}

		return RecruitmentVacancyPurpose.getBy(trimmed) as RecruitmentVacancyPurpose | undefined;
	}

	public static resolveLabel(
		purpose: number | string | null | undefined,
		fallback = RecruitmentVacancyPurpose.NOT_INFORMED_LABEL
	): string {
		return RecruitmentVacancyPurpose.resolve(purpose)?.label ?? fallback;
	}

	public static isHeadcountIncrease(purpose: number | string | null | undefined): boolean {
		const resolved = RecruitmentVacancyPurpose.resolve(purpose);
		return resolved === RecruitmentVacancyPurpose.HeadcountIncrease;
	}
}
